import React, { useState } from "react";
import { toast } from "react-toastify";
import { uploadFirmware } from "../../services/firmwareService";
import { Icon } from "@iconify/react/dist/iconify.js";

const FirmwareManageLayer = () => {
  const [version, setVersion] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!version.trim()) {
      toast.error("Please enter firmware version");
      return;
    }
    if (!file) {
      toast.error("Please select a firmware file (.bin)");
      return;
    }

    setLoading(true);
    try {
      const res = await uploadFirmware(version, file);
      const data = res.data || res;
      
      if (data.status === "success" || data.status === true) {
        toast.success(data.message || "Firmware uploaded successfully");
        setVersion("");
        setFile(null);
        // Reset the file input element visually
        document.getElementById("fw_file").value = "";
      } else {
        toast.error(data.message || "Failed to upload firmware");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center justify-content-between">
        <h6 className="text-lg fw-semibold mb-0">Firmware Management</h6>
      </div>
      <div className="card-body p-24">
        <form onSubmit={handleSubmit}>
          <div className="row gy-4">
            <div className="col-md-6">
              <label htmlFor="version" className="form-label fw-semibold text-primary-light text-sm mb-8">
                Firmware Version <span className="text-danger-600">*</span>
              </label>
              <input
                type="text"
                className="form-control radius-8"
                id="version"
                placeholder="e.g., 1.0.9"
                value={version}
                onChange={(e) => setVersion(e.target.value)}
              />
            </div>
            
            <div className="col-md-6">
              <label htmlFor="fw_file" className="form-label fw-semibold text-primary-light text-sm mb-8">
                Firmware File (.bin) <span className="text-danger-600">*</span>
              </label>
              <input
                type="file"
                className="form-control radius-8"
                id="fw_file"
                accept=".bin"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </div>
            
            <div className="col-12 mt-4">
              <button 
                type="submit" 
                className="btn btn-primary-600 radius-8 px-20 py-11 d-flex align-items-center gap-2"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Uploading...
                  </>
                ) : (
                  <>
                    <Icon icon="lucide:upload" className="text-xl" />
                    Upload Firmware
                  </>
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FirmwareManageLayer;
